module.exports = __webpack_public_path__ + "static/media/usedmachineryformimage - Copy.65ed4d34.jpg";